// Legacy authentication returns 403; an ordinary permission denial must remain distinct.
export function isSessionExpiredResponse (response) {
  return response?.status === 401 || (response?.status === 403 && ['Invalid token', 'Token expired', 'No token provided'].includes(response.data?.error))
}
